import { createVanIconComponent } from "./van"

const Certificate = createVanIconComponent("certificate")
export default Certificate
